//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import { call }                   from 'redux-saga/effects';
import { put }                    from 'redux-saga/effects';
import { takeLatest }             from 'redux-saga/effects';
import * as Api                   from '@/api';
import { ConfigurationTypes }     from '@/store/actions/configuration';
import { ConfigurationActions }   from '@/store/actions/configuration';

function* fetchConfiguration() {
    const response = yield call(Api.fetchConfiguration);

    if (response.ok) {
        yield put(ConfigurationActions.fetchConfigurationSucceeded({
            maxUploadSizeInBytes: response.data.maxUploadSizeInBytes,
        }));
    } else {
        yield put(ConfigurationActions.fetchConfigurationFailed());
    }
}

export const callConfigurationSagas = () => {
    return [
        // @formatter:off
        takeLatest([ConfigurationTypes.FETCH_CONFIGURATION], fetchConfiguration),
        // @formatter:on
    ];
};

export default {
    fetchConfiguration,
};
